import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignServiceService } from '../campaign-service.service';
import { Campaign, CampaignDealLine } from '../model';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SkeletonModule } from 'primeng/skeleton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToolbarModule } from 'primeng/toolbar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DatePipe, NgFor } from '@angular/common';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { TabViewModule } from 'primeng/tabview';
import { EditorModule } from 'primeng/editor';

@Component({
    selector: 'app-campaign',
    imports: [
        DatePipe,
        ConfirmPopupModule, ToastModule, DropdownModule,
        FormsModule, InputTextModule, SkeletonModule,
        InputSwitchModule, InputNumberModule, ToolbarModule, TableModule,
        ButtonModule, TabViewModule, EditorModule, NgFor
    ],
    providers: [ConfirmationService, MessageService],
    templateUrl: './campaign.component.html',
    styleUrl: './campaign.component.scss'
})
export class CampaignComponent implements OnInit {

  protected campaign: Campaign | null = null;
  protected flowOptions: any[] = [{
    label: 'Sales',
    value: 1
  }, {
    label: 'Renewal',
    value: 2
  }, {
    label: 'Upselling',
    value: 3
  }];
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: CampaignServiceService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService) {


  }

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.url[1].path == 'add') {
      this.campaign = {
        id: 0,
        name: '',
        isActive: false,
        createAllDealsAtActivation: false,
        crmCampaign: false,
        iHostCampaign: false,
        crmId: '',
        crmLabelName: '',
        crmLabelId: 0,
        crmAudienceFilterId: 0,
        crmUserClickedFilterId: 0,
        crmFlowId: 0,
        crmInitialStageIndex: 1,
        crmInitialStageId: 0,
        crmClickedStageIndex: 2,
        crmClickedStageId: 0,
        lines: [],
        createdDeals: [],
        description: [
          { lang: 'en', value: '' },
          { lang: 'el', value: '' },
          { lang: 'hr', value: '' },
        ]
      };
    } else {
      const id = this.activatedRoute.snapshot.params['id'];
      this.service.get(id).subscribe(data => {
        this.campaign = data;
      });
    }
  }

  canActivate() {
    if (this.campaign == null || this.campaign.id == 0) {
      return false;
    }

    if (this.campaign.isActive) {
      return false;
    }

    return true;
  }

  canDeactivate() {
    if (this.campaign == null || this.campaign.id == 0) {
      return false;
    }

    if (!this.campaign.isActive) {
      return false;
    }

    return true;
  }

  canclean() {
    if (this.campaign == null || this.campaign.id == 0) {
      return false;
    }

    if (this.campaign.isActive) {
      return false;
    }

    return this.campaign.dateActivated != null;
  }

  addLine() {
    if (this.campaign == null) {
      return;
    }

    this.campaign.lines.push({
      id: 0,
      crmProductId: '',
      itemPrice: 0,
      quantity: 1
    });
  }

  removeLine(item: CampaignDealLine) {
    if (this.campaign == null) {
      return;
    }

    this.campaign.lines = this.campaign.lines.filter(x => x != item);
  }

  exit() {
    this.router.navigate(['/campaigns']);
  }

  activate(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.activate(this.campaign!.id).subscribe((data) => {
          this.campaign = data;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Campaign Activated',
            life: 3000
          });
        }, err => {
          this.messageService.add({
            severity: 'error',
            summary: 'Campaign cannot be activated',
            detail: err.message,
            life: 5000
          });
        });
      },
      reject: () => {
      }
    });
  }

  deactivate(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.deactivate(this.campaign!.id).subscribe((data) => {
          this.campaign = data;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Campaign Dectivated',
            life: 3000
          });
        }, err => {
          this.messageService.add({
            severity: 'error',
            summary: 'Campaign cannot be deactivated',
            detail: err.message,
            life: 5000
          });
        });
      },
      reject: () => {
      }
    });
  }

  clean(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to delete all pending pipedrive deals?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.clean(this.campaign!.id).subscribe((data) => {
          this.campaign = data;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Campaign Cleaned',
            life: 3000
          });
        }, err => {
          this.messageService.add({
            severity: 'error',
            summary: 'Campaign cannot be activated',
            detail: err.message,
            life: 5000
          });
        });
      },
      reject: () => {
      }
    });
  }

  save(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.save(this.campaign!).subscribe((data) => {
          this.campaign = data;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Campaign Saved',
            life: 3000
          });
        }, err => {
          this.messageService.add({
            severity: 'error',
            summary: 'Campaign cannot be saved',
            detail: err.message,
            life: 5000
          });
        });
      },
      reject: () => {
      }
    });
  }
}
